// extracted by mini-css-extract-plugin
export default {"topUp":"TopUp_topUp__RqjXs","info":"TopUp_info__jZsMc","infoItem":"TopUp_infoItem__+RUt5","header":"TopUp_header__eL0Zr"};